import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

export const fetchachievemnetById = createAsyncThunk(
    'performance/fetchachievementById',
    async ( {Id} : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/performance/achievement/${Id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Achievement');
        }
    }
);

export const createachievemnet = createAsyncThunk(
    'performance/createachievement',
    async ( data: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.post(`/performance/achievement`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Achievement');
        }
    }
);
export const updateachievemnet = createAsyncThunk(
    'performance/updateachievement',
    async (  {Id ,data} : any , { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.put(`/performance/achievement/${Id}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update Achievement');
        }
    }
);